module.exports = __webpack_public_path__ + "fonts/ProximaNovaACond-Extrabld.36172d130f9a4c81738abd0541c792f5.ttf";